module.exports = __webpack_public_path__ + "static/media/bg_portfolio-rmbg.7630a08f.png";